/**
 * ng-expertiza.ru
 * Базовый миксин для отправки модальных форм
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

export default {
    data() {
        return {
            formState: {},

            form: {
                person: null,
                tel   : null,
                email: '',
            },

            formSending : false,
            formSent    : false,
            formDisabled: false,

            formErrorMessage: '',

            formHasFiles: false,
        };
    },

    mounted() {
        $(this.$el).data('vm', this);
        this.$on('show.dpr.modal', this.onShow);
    },

    computed: {
        submitClass() {
            return {
                'is-loading': this.formSending,
            };
        },
    },

    methods: {
        reset() {
            this.formState._reset();
            this.form = {
                person: null,
                tel   : null,
            };
        },

        collectData() {
            this.formHasFiles = false;

            let fd  = new FormData();
            let tmp = {};
            fd.append('field_Email', 'Email');
            fd.append('value_Email', '');

            this.$el.querySelectorAll('input, textarea').forEach(el => {
                if (el.name && (
                    el.type === 'hidden'
                    || el.type === 'email'
                    || el.type === 'text'
                    || el.type === 'tel'
                    || el.type === 'textarea'
                    || el.type === 'file'
                )) {
                    fd.append('field_' + el.name, el.dataset.alt);
                    fd.append('value_' + el.name, el.value);
                    tmp['field_' + el.name] = el.dataset.alt;
                    tmp['value_' + el.name] = el.value;

                    if (el.type === 'file') {
                        fd.append('img', el.files[0]);
                        this.formHasFiles = true;
                    }
                }
            });

            console.table(tmp);
            return fd;
        },

        send(event) {
            if (this.formState.$invalid) {
                console.log('(!) Form isn\'t valid');
                return;
            }

            this.formSending      = true;
            this.formErrorMessage = '';
            this.formDisabled     = true;

            let fd = this.collectData();

            setTimeout(() => {
                $.ajax({
                    url        : '/ajax/consult',
                    type       : 'POST',
                    data       : fd,
                    processData: false,
                    contentType: false,
                    success    : () => {
                        setTimeout(() => {
                            this.formSending = false;
                            this.formSent    = true;
                            this.reset();
                        }, 1500);
                        setTimeout(() => {
                            this.formDisabled = false;
                            $('.modals-close').trigger('click');
                        }, 2500);
                    },
                    error      : error => {
                        this.formSending      = false;
                        this.formDisabled     = false;
                        this.formErrorMessage = error.status + ' ' + error.statusText;
                        console.error('ERROR!');
                    },
                });
            }, 1000);
        },

        formGroupState(fieldState) {
            return {
                invalid: fieldState && (this.formState.$submitted || fieldState.$touched) && fieldState.$invalid,
            };
        },

        onShow() {
            this.reset();
            this.formSending      = false;
            this.formSent         = false;
            this.formErrorMessage = '';
            this.formDisabled = false;
        },
    },
};
